import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Scale, Total } from "@pdfking/math"

/** The part of `box` from `left` to `right` across and `bottom` to `top`
 * up, each a share of it from its left or its foot. */
export const Region = (
  box: SpatialRectangle<Distance>,
  left: number,
  bottom: number,
  right: number,
  top: number
): SpatialRectangle<Distance> => ({
  height: Scale(box.height, top - bottom),
  width: Scale(box.width, right - left),
  x: Total(box.x, Scale(box.width, left)),
  y: Total(box.y, Scale(box.height, bottom)),
})
